import blank from '../../Blank/blankData'

const data = [blank]

export default data
